import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton, Theme } from '@material-ui/core'
import DownloadIcon from '@src/icons/DownloadIcon'

const useStyles = makeStyles((theme: Theme) => {
  return {
    bulkUploadTemplateButton: {
      padding: 0,
      borderRadius: 0,
      color: theme.palette.secondary.light,
      '&:hover': {
        background: 'none',
        textDecoration: 'none',
        borderBottom: 'none',
      },
    },
    bulkUploadTemplateIcon: {
      display: 'flex',
      height: theme.typography.pxToRem(14),
      width: theme.typography.pxToRem(14),
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.primary.main,
    },
    bulkUploadTemplateText: {
      fontSize: theme.typography.pxToRem(16),
      marginLeft: theme.spacing(2),
      color: theme.palette.primary.main,
    },
  }
})

interface DownloadsItem {
  url: string
  label: React.ReactNode
  fileName: string
  productType: string
}

interface DownloadsItemProps {
  item: DownloadsItem
  onClick?: (item) => void
}

const DownloadTemplateLink: React.FC<DownloadsItemProps> = ({
  item,
  onClick,
}) => {
  const classes = useStyles()
  return (
    <IconButton
      className={classes.bulkUploadTemplateButton}
      href={item.url}
      download={item.fileName}
      onClick={() => (onClick ? onClick(item) : {})}
    >
      <div>
        <DownloadIcon className={classes.bulkUploadTemplateIcon} />
      </div>
      <div className={classes.bulkUploadTemplateText}>{item.label}</div>
    </IconButton>
  )
}

export default DownloadTemplateLink
